module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "operate"
  }, [_c('header', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('div', {
    staticClass: "my-operate"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "logined",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "J_Logined"
    }
  }, [_c('span', {
    staticClass: "mypic"
  }, [_c('img', {
    attrs: {
      "src": _vm.myInfo.headurl
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "myname"
  }, [_vm._v(_vm._s(_vm.myInfo.username))]), _vm._v(" "), _c('span', {
    staticClass: "myphone"
  }, [_vm._v(_vm._s(_vm.myInfo.tel))])]), _vm._v(" "), _c('div', {
    staticClass: "operate-menu J_OperateMenu"
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "linkrecord",
    attrs: {
      "href": "javascript:;",
      "data-url": "/#/record"
    },
    on: {
      "click": function($event) {
        _vm.even('record')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("电子病历")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "linkreport",
    attrs: {
      "href": "javascript:;",
      "data-url": "/#/report"
    },
    on: {
      "click": function($event) {
        _vm.even('report')
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("体检报告")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "linkmyorder",
    attrs: {
      "href": "javascript:;",
      "data-url": "/#/myOrder"
    },
    on: {
      "click": function($event) {
        _vm.even('myorder')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("我的预约")])])]), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), _c('MenuFooters', {
    attrs: {
      "isHide": _vm.isHide,
      "menuType": _vm.currentMenuType
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nologin",
    attrs: {
      "id": "J_NoLogin"
    }
  }, [_c('a', {
    attrs: {
      "href": "/#/login/my"
    }
  }, [_vm._v("登录/注册")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/my_i1.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/my_i2.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/my_i3.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "linkcollect",
    attrs: {
      "href": "javascript:;",
      "data-url": "javascript:;"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/my_i4.png")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("收藏")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0b6d5b66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/My.vue
// module id = 188
// module chunks = 1